<script setup lang="ts">
import { computed } from 'vue'
import ProductSharingPostList from '@/legacy/components/ProductSharingPostList.vue'
import {
	productSharingPostPerPage,
	productSharingPostColumn,
} from '@/legacy/ts/productSharing'
import { useBreakpoints } from '@/lib/utils'

const { isLarge, isTabletLandscape, isMedium } = useBreakpoints()
const emit = defineEmits(['notify-list-empty'])
const props = defineProps({
	text: {
		type: Object,
		required: true,
	},
	query: {
		type: String,
		required: true,
	},
	localCurrencyInfo: {
		type: Array,
		default: null,
	},
})

const columnCount = computed(() => {
	if (isLarge.value) return productSharingPostColumn.SizeLG
	if (isTabletLandscape.value) return productSharingPostColumn.SizeMDL
	if (isMedium.value) return productSharingPostColumn.SizeMDP
	return productSharingPostColumn.SizeSM
})

const sectionTitle = computed(() => {
	return props.text.community.title.replace('{brand}', props.query)
})

const sectionDescription = computed(() => {
	return props.text.community.description.replace('{brand}', props.query)
})

function notifyListEmpty() {
	emit('notify-list-empty')
}
</script>

<template>
	<section class="bg-o-50">
		<div class="bs-container py-distant-acquaintances">
			<div class="col-span-12">
				<h2 class="typography-h3-str mb-16px text-center text-n-950">
					{{ sectionTitle }}
				</h2>
				<p class="typography-s1-reg text-center text-n-800">
					{{ sectionDescription }}
				</p>
				<ProductSharingPostList
					v-if="query"
					class="pt-casual-friends"
					:columnCount="columnCount"
					:postPerPage="productSharingPostPerPage.search"
					:isSearch="true"
					:text="text.postListTextInfo"
					:searchKeyword="query"
					:isTypeModal="false"
					:isMercariBrand="true"
					:localCurrencyInfo="localCurrencyInfo"
					@notify-list-empty="notifyListEmpty"
				/>
			</div>
		</div>
	</section>
</template>
